import {secureFetch} from './authService';
import {API_BASE_URL, PAGINATION_DEFAULT_LIMIT} from './constants';

export function getLocalizedOfferPrefs(query) {
    let url = API_BASE_URL + '/trade/offerPrefs/localized?';
    if (query) {
        const {lang = 'ru', companyIds, countryCodes, cityGeonameIds} = query;
        url = url + `&lang=${lang}`;

        if (companyIds) {
            url = url + `&companyIds=${companyIds}`;
        }

        if (countryCodes) {
            url = url + `&countryCodes=${countryCodes}`;
        }

        if (cityGeonameIds) {
            url = url + `&countryCodes=${countryCodes}`;
        }
    }

    return secureFetch(url, {
        method: 'GET',
    });
}

export function getBasicOfferPrefs() {
    let url = API_BASE_URL + '/trade/offerPrefs/basic?';
    return secureFetch(url, {
        method: 'GET',
    });
}

export function getPromoAppsStat(query) {
    let url = API_BASE_URL + '/trade/statistic/apps?';
    if (query) {
        const {
            traderCompanyId,
            appLabels,
            dateFrom,
            dateTo,
            filters,
            limit = PAGINATION_DEFAULT_LIMIT,
            page = 0,

        } = query;

        if (traderCompanyId) {
            url = url + `&traderCompanyId=${traderCompanyId}`;
        }

        if (appLabels && appLabels.length) {
            url = url + `&appLabels=${appLabels}`;
        }

        if (dateFrom) {
            url = url + `&dateFrom=${dateFrom}`;
        }

        if (dateTo) {
            url = url + `&dateTo=${dateTo}`;
        }

        if (filters && filters.length) {
            console.log('filters', filters);
            filters.forEach(filter => {
                if (filter.value) {
                    url = url + `&${filter.name}=${filter.value}`;
                }
            });
        }

        if (limit) {
            url = url + `&limit=${limit}`;
        }

        if (page || page === 0) {
            url = url + `&page=${page}`;
        }
    }

    return secureFetch(url, {
        method: 'GET',
    });
}

export function getOffersStat(query) {
    let url = API_BASE_URL + '/trade/statistic/offers?';
    if (query) {
        const {
            traderCompanyId,
            dateFrom,
            dateTo,
            paymentModelId,
            appLabels,
            filters,
            limit = PAGINATION_DEFAULT_LIMIT,
            page = 0,

        } = query;

        if (traderCompanyId) {
            url = url + `&traderCompanyId=${traderCompanyId}`;
        }

        if (dateFrom) {
            url = url + `&dateFrom=${dateFrom}`;
        }

        if (dateTo) {
            url = url + `&dateTo=${dateTo}`;
        }

        if (paymentModelId) {
            url = url + `&paymentModelId=${paymentModelId}`;
        }

        if (appLabels && appLabels.length) {
            url = url + `&appLabels=${appLabels}`;
        }

        if (filters && filters.length) {
            console.log('filters', filters);
            filters.forEach(filter => {
                if (filter.value) {
                    url = url + `&${filter.name}=${filter.value}`;
                }
            });
        }

        if (limit) {
            url = url + `&limit=${limit}`;
        }

        if (page || page === 0) {
            url = url + `&page=${page}`;
        }
    }

    return secureFetch(url, {
        method: 'GET',
    });
}

export function getRetailerCallsStat(query) {
    let url = API_BASE_URL + '/trade/statistic/retailerCalls?';
    if (query) {
        const {
            retailerCompanyId,
            dateFrom,
            dateTo,
            paymentModelId,
            appLabels,
            filters,
            page = 0,
            limit = PAGINATION_DEFAULT_LIMIT,

        } = query;

        if (retailerCompanyId) {
            url = url + `&retailerCompanyId=${retailerCompanyId}`;
        }

        if (dateFrom) {
            url = url + `&dateFrom=${dateFrom}`;
        }

        if (dateTo) {
            url = url + `&dateTo=${dateTo}`;
        }

        if (paymentModelId) {
            url = url + `&paymentModelId=${paymentModelId}`;
        }

        if (appLabels) {
            url = url + `&appLabels=${appLabels}`;
        }

        if (filters && filters.length) {
            filters.forEach(filter => {
                if (filter.value) {
                    url = url + `&${filter.name}=${filter.value}`;
                }
            });
        }

        if (page || page === 0) {
            url = url + `&page=${page}`;
        }

        if (limit) {
            url = url + `&limit=${limit}`;
        }
    }

    return secureFetch(url, {
        method: 'GET',
    });
}

export function getRedirectsStat(query) {
    let url = API_BASE_URL + '/trade/statistic/redirects?';
    if (query) {
        const {
            traderCompanyId,
            filters,
            retailerCompanyId,
            dateFrom,
            dateTo,
            limit = PAGINATION_DEFAULT_LIMIT,
            page = 0,

        } = query;

        if (traderCompanyId) {
            url = url + `&traderCompanyId=${traderCompanyId}`;
        }

        if (filters && filters.length) {
            filters.forEach(filter => {
                if (filter.value) {
                    url = url + `&${filter.name}=${filter.value}`;
                }
            });
        }

        if (retailerCompanyId) {
            url = url + `&retailerCompanyId=${retailerCompanyId}`;
        }

        if (dateFrom) {
            url = url + `&dateFrom=${dateFrom}`;
        }

        if (dateTo) {
            url = url + `&dateTo=${dateTo}`;
        }

        if (limit) {
            url = url + `&limit=${limit}`;
        }

        if (page || page === 0) {
            url = url + `&page=${page}`;
        }
    }

    return secureFetch(url, {
        method: 'GET',
    });
}

export function addOffer(offer) {
    return secureFetch(API_BASE_URL + '/trade/offer', {
        method: 'POST',
        body: offer
    }, {});
}

export function updateOffer(id, offer) {
    return secureFetch(API_BASE_URL + '/trade/offer/' + id, {
        method: 'PUT',
        body: offer
    }, {});
}

export function getOffers(query) {
    let url = API_BASE_URL + '/trade/offer?';
    if (query) {
        const {page = 0, limit = PAGINATION_DEFAULT_LIMIT} = query;

        if (limit) {
            url = url + `&limit=${limit}`;
        }

        if (page || page === 0) {
            url = url + `&page=${page}`;
        }
    }

    return secureFetch(url, {
        method: 'GET',
    });
}

export function getOffer(id) {
    const url = API_BASE_URL + `/trade/offer/${id}`;

    return secureFetch(url, {
        method: 'GET',
    });
}

export function deleteOffer(id) {
    const url = API_BASE_URL + `/trade/offer/${id}`;

    return secureFetch(url, {
        method: 'DELETE',
    });
}



// WEBPACK FOOTER //
// ./src/helpers/promoService.js